import Vue from 'vue'

const scroll = (container, direction) => {
    if (!direction) return

    if (direction === 'top') {
        container.scrollTop = 0
    } else if (direction === 'bottom') {
        container.scrollTop = container.scrollHeight
    }
}


/**
 * How to use:
 * 
 * @uses  v-scroll-to:[:direction]="[:list]"
 * @param {String} direction - can be 'top' or 'bottom'
 * @param {Array} list - the list it should scroll
 * 
 * @example
 * <ul v-scroll-to:bottom="myProducts">
    <li v-for="p in myProducts" :key="p">{{p}}</li>
 * </ul>
 */

Vue.directive('scroll-to', {
    inserted(el, binding, vnode, old) {
        el.style['scroll-behavior'] = "smooth"

        scroll(el, binding.arg)
    },
    componentUpdated(el, binding, vnode, old) {
        const {oldValue, value} = binding
        if (oldValue.length === value.length) return

        scroll(el, binding.arg)
    },
})